var contactMap = undefined;
var tyMap = undefined;
var listMap = undefined;
var streetviewMap = undefined;
var detailMap = undefined;
var markers = [];
var mobileResoluction=750;
var styles = {
    default: [],
    hide: [
        {
            "stylers": [
                {
                    "saturation": -15
                },
                {
                    "lightness": 30
                }
            ]
        },
        {
            "featureType": "poi.attraction",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi.business",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi.government",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi.medical",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "labels.text",
            "stylers": [
                {
                    "color": "#aaaaaa"
                },
                {
                    "weight": 0.5
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#999999"
                }
            ]
        },
        {
            "featureType": "poi.place_of_worship",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi.school",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi.sports_complex",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "stylers": [
                {
                    "color": "#ffffff"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "labels.text",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "transit",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        }
    ],
};

function initMap() {
    $(".gmap").each(function () {
        if($(this).attr("id")=="contactmap") {
            initStaticMap();
        }
    });
}

function initStaticMap() {
    var centerMap = (window.innerWidth<=mobileResoluction) ?  {lat: 48.866455,lng: 2.2883952} : {lat: 48.8664762, lng: 2.2837925};
    var officeLocation = {lat: 48.866455,lng: 2.2883952};
    var zoom = 17;
    //Init MAP
    contactMap = new google.maps.Map(
        document.getElementById('contactmap'), {
            'center' : centerMap,
            'zoom' : zoom,
            'mapTypeControl': false,
            streetViewControl: false,
            disableDefaultUI: true,
            gestureHandling: 'none',
            'styles':styles["hide"]
        }
    );
    //Init Marker
    var marker = new google.maps.Marker({
        'position': officeLocation,
        'map': contactMap,
        'title': '',
        'icon':{ url: "https://cdn.shopify.com/s/files/1/0691/5175/2503/files/icon-marker-maison.png?v=1678214197"
        }
    });
}

$( window ).resize(function() {
    if(contactMap!=undefined) {
        (window.innerWidth<=mobileResoluction) ?  contactMap.setCenter({lat: 48.866455,lng: 2.2883952}) : contactMap.setCenter({lat: 48.8664762, lng: 2.2837925});
    }
});